export default "__VITE_ASSET__88vZmDQV__"